import * as _ from 'lodash';
import {ACTIONS} from './../constants';

export const compareBucket = (state = {currentModel: {}, bucket: []}, action = {}) => {
    switch (action.type) {
        case ACTIONS.ADD_MODEL_TO_COMPARE_BUCKET :
            return {
                ...state,
                bucket: [...state.bucket, action.model]
            };
        case ACTIONS.REMOVE_MODEL_FROM_COMPARE_BUCKET :
            return {
                ...state,
                bucket: _.filter(state.bucket, _.conforms({ id : (id) => { return id !== action.id; }}))
            };
        default :
            return state;
    }
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/reducers/index.js